module.exports = __webpack_public_path__ + "img/maintenance.401a4d4c.svg";